import { Field, Float, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import GraphQLJSON from 'graphql-type-json'

@InputType()
export class SaveMilkPickupArgs extends ActionArgs {
  @Field(() => ID, { nullable: true })
  _id?: string

  @Field(() => String, { nullable: true })
  ticketNo?: string

  @Field(() => Date, { nullable: true })
  timeStamp?: Date

  @Field(() => String, { nullable: true })
  status?: string

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => Float, { nullable: true })
  grossWeight?: number

  @Field(() => Float, { nullable: true })
  tareWeight?: number

  @Field(() => Float, { nullable: true })
  netWeight?: number

  @Field(() => String, { nullable: true })
  manifestNo?: string

  @Field(() => [String], { nullable: true })
  sealNo?: string[]

  @Field(() => [String], { nullable: true })
  tags?: string[]

  @Field(() => GraphQLJSON, { nullable: true })
  templateData?: Record<string, unknown>
}
